import React from "react";
import { Box, Button, Stack } from "@mui/material";

import PrintIcon from "@mui/icons-material/Print";
import GridOnIcon from "@mui/icons-material/GridOn";

import Modal from "../../common/modal";

import TripPreview from "./TripPreview";

const ViewLoadModal = ({
  open,

  trip,

  lrRows = [],

  dispatchCity = "",
  dispatchBranch = "",

  onPrint,
  onExcel,
  onClose,
}) => {
  if (!open) return null;

  return (
    <Modal
      width="95%"
      height="85%"
      headTxt="DISPATCH LOAD PLAN PREVIEW"
      updateModal={onClose}
    >
      <Box p={2} sx={{ height: "calc(100% - 52px)", overflow: 'scroll' }}>
        <Stack
          direction="row"
          justifyContent="flex-end"
          spacing={2}
          sx={{
            mt: 0,
            pb: 2,
          }}
        >
          <Button
            variant="contained"
            startIcon={<PrintIcon />}
            onClick={onPrint}
          >
            Print
          </Button>

          <Button
            variant="contained"
            startIcon={<GridOnIcon />}
            onClick={onExcel}
            sx={{
              background: "#14833b",
              "&:hover": {
                background: "#0f6d31",
              },
            }}
          >
            Export Excel
          </Button>

          <Button
            variant="outlined"
            color="error"
            onClick={onClose}
          >
            Close
          </Button>
        </Stack>
        <TripPreview
          trip={trip}
          lrRows={lrRows}
          dispatchCity={dispatchCity}
          dispatchBranch={dispatchBranch}
        />

      </Box>
    </Modal>
  );
};

export default ViewLoadModal;